<template>
    <div>
        <a-modal :title="title" :visible=sureVisible :width="1200" @ok="handleOk" @cancel="handleCancel">
            <template slot="footer">
                <a-button @click="handleCancel">关闭</a-button>
            </template>
            <div>
                <span class="basicTitle">基本信息</span>
                <a-row>
                    <a-col :span="12/1">
                        <p>企业名称：</p>
                        <span>{{ basicInfo.company }}</span>
                    </a-col>
                    <a-col :span="12/1">
                        <p>编码：</p>
                        <span>{{ basicInfo.companyCode }}</span>
                    </a-col>
                    <a-col :span="12/1">
                        <p>法定代表人:</p>
                        <span>{{ basicInfo.legal }}</span>
                    </a-col>
                    <a-col :span="12/1">
                        <p>企业负责人:</p>
                        <span>{{ basicInfo.businessManager }}</span>
                    </a-col>
                    <a-col :span="12/1">
                        <p>质量负责人:</p>
                        <span>{{ basicInfo.qualityManager }}</span>
                    </a-col>
                    <a-col :span="12/1">
                        <p>统一社会信用代码:</p>
                        <span>{{ basicInfo.credit }}</span>
                    </a-col>
                    <a-col :span="12/1">
                        <p>注册资金:</p>
                        <span>{{ basicInfo.capital }}</span>
                    </a-col>
                    <a-col :span="12/1">
                        <p>申请原因:</p>
                        <span>{{ basicInfo.reason }}</span>
                    </a-col>
                </a-row>
            </div>
            <div>
                <span class="lisenceTitle" >证照信息</span>
                <a-row>
                    <a-col :span="12/1">
                        <p>证照类型：</p>
                        <span>{{ basicInfo.company }}</span>
                    </a-col>
                    <a-col :span="12/1">
                        <p>证照编码：</p>
                        <span>{{ basicInfo.companyCode }}</span>
                    </a-col>
                    <a-col :span="12/1">
                        <p>有效期起:</p>
                        <span>{{ basicInfo.legal }}</span>
                    </a-col>
                    <a-col :span="12/1">
                        <p>有效期至:</p>
                        <span>{{ basicInfo.businessManager }}</span>
                    </a-col>
                    <a-col :span="12/1">
                        <p>预警天数:</p>
                        <span>{{ basicInfo.businessManager }}</span>
                    </a-col>
                    <a-col :span="12/1">
                        <p>纸质文件编码:</p>
                        <span>{{ basicInfo.businessManager }}</span>
                    </a-col>
                    <a-col :span="12/1">
                        <p>备注:</p>
                        <span>{{ basicInfo.legal }}</span>
                    </a-col>
                    <a-col :span="12/1">
                        <p>查看附件:</p>
                        <span>{{ basicInfo.legal }}</span>
                    </a-col>
                </a-row>
            </div>
        </a-modal>
    </div>
</template>
<script>
// import { defineComponent } from '@vue/composition-api'

export default { 
    name: 'campDetail',
    data() {
      return { 
        title: '商品信息审核',
        sureVisible:false,
        basicInfo: {
            company: '测试',
            companyCode: '测试-123456',

        }
      }
    },
    methods: {
        initShow(e){
            console.log(e,'======================e===============')
            this.sureVisible = true
        },
        handleOk(){
            this.sureVisible = false
        },
        handleCancel(){
            this.sureVisible = false
        },
    }
}
</script>
<style lang="less" scoped>
    /deep/.ant-col {
        display: flex;
    }
    .basicTitle {
        display: block;
        font-size: 16x;
        margin: 0 0 30px;
        padding-left: 10px;
        border-left: 4px solid #1890FF;
    }
    .lisenceTitle {
        display: block;
        font-size: 16x;
        margin: 30px 0 30px;
        padding-left: 10px;
        border-left: 4px solid #1890FF;
    }
</style>
